import { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { handleNumberOnly, isNumber } from "../../../utils/utils";
import Ciot from "./Ciot";
import Contratante from "./Contratante";
import ValePedagio from "./ValePedagio";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { changeAnttRntrc } from "../../../features/manifestoSlice";
import InfPagFrete from "./InfPagFrete";

export default function Antt() {
    const [showTabs, setShowTabs] = useState(false);
    const dispatch = useDispatch()
    const form = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario?.infANTT);

    const handleChange = (e: any) => {
        const { _, value } = e.target;
        dispatch(changeAnttRntrc(value?.trim()))
    }

    const disableRntrc = () => {
        if (form?.infCIOT?.length > 0 || form?.infContratante?.length > 0 ||
            form?.indPag?.length > 0 || form?.valePed?.length > 0) {
            return true
        }
        return false
    }

    useEffect(() => {
        if (isNumber(form.rntrc)) {
            setShowTabs(true);
        } else {
            setShowTabs(false)
        }
    }, [form.rntrc])

    return (<>
        <Tabs defaultActiveKey="annt_rntrc" id="tab-rodoviario" className="mb-3">

            <Tab key={1} eventKey="annt_rntrc" title="RNTRC" className="px-2">
                <Row className="mb-3">
                    <Col md={2}>
                        <Form.Group controlId="codigo-rntrc">
                            <Form.Label>RNTRC</Form.Label>
                            <Form.Control name="rntrc" type="text" onKeyUp={handleNumberOnly} 
                                onChange={handleChange} value={form.rntrc} maxLength={8} disabled={disableRntrc()} />
                        </Form.Group>

                    </Col>
                </Row>
            </Tab>

            {showTabs && (
                <Tab key={2} eventKey="annt_ciot" title="CIOTs" className="px-2">
                    <Ciot />
                </Tab>
            )}

            {showTabs && (
                <Tab key={3} eventKey="annt_contratante" title="Contratantes" className="px-2">
                    <Contratante />
                </Tab>
            )}

            {showTabs && (
                <Tab key={4} eventKey="annt_valepedagio" title="Vale Pedágio" className="px-2">
                    <ValePedagio />
                </Tab>
            )}

            {showTabs && (
                <Tab key={5} eventKey="annt_infPagFrete" title="Informação do Pagamento do Frete" className="px-2">
                    <InfPagFrete />
                </Tab>
            )}
        </Tabs>

    </>)
}
